// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__354eF","savePackageButton":"ClientWallet_savePackageButton__1v-G1"};